import $ from 'jquery';

$('#page-header__tab-group').click(function (e) {
	e.preventDefault();
	const $tabToggle = $(e.target),
		id = $tabToggle.data('id'),
		$tabPanels = $('.archive-filters__content');

	// If the clicked tab already has the active class, collapse the tab panels and remove the active class,
	// then return so other code doesn't get executed.
	if ($tabToggle.hasClass('active')) {
		$tabPanels.slideUp();
		$tabToggle.removeClass('active');
		return;
	}

	// Remove all active classes from tabs and collapse tab panels.
	$('#page-header__tab-group a').removeClass('active');
	$tabPanels.slideUp();

	// Open the corresponding tab panel for the one that was just clicked
	$('.archive-filters__content[data-content=' + id + ']' ).slideDown();
	// Add the active class to the current tab
	$tabToggle.addClass('active');
});
